import { render, staticRenderFns } from "./FAQManagementDetail.vue?vue&type=template&id=b6a978a2&scoped=true"
import script from "./FAQManagementDetail.vue?vue&type=script&lang=js"
export * from "./FAQManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./FAQManagementDetail.vue?vue&type=style&index=0&id=b6a978a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a978a2",
  null
  
)

export default component.exports